import React, { Fragment } from 'react';
import Media from 'react-media';
import { branch, renderNothing } from 'recompose';
import {
  HeaderNavItemWithBorder,
  CartIconWrapper,
  CartItemsCount,
  ItemTextWrapper,
  ItemTextSmall,
  ItemTextLarge,
} from './style';
import Toggle from '../toggle';
import CartIcon from '../../images/cartIcon';
import ProfileIcon from '../../images/profileIcon';

const hideIfNoData = hasNoData => branch(hasNoData, renderNothing);

const enhancedItemsCount = hideIfNoData(props => !props.itemsCount);
const ItemsCount = enhancedItemsCount(({ itemsCount, left }) => (
  <CartItemsCount left={left}>{itemsCount}</CartItemsCount>
));

const enhancedCartTotal = hideIfNoData(props => !props.total);
const CartTotal = enhancedCartTotal(({ total }) => (
  <ItemTextLarge>{total}</ItemTextLarge>
));

export const HeaderCartItem = ({ toggleCart, total, itemsCount }) => {
  return (
    <HeaderNavItemWithBorder>
      <Toggle onClick={toggleCart}>
        <CartIconWrapper>
          <ItemsCount
            itemsCount={itemsCount}
            left={itemsCount > 9 ? '35%' : '45%'}
          />
          <CartIcon fill="rgba(101,116,205,1)" width={35} height={35} />
        </CartIconWrapper>
        <Media query="(min-width: 64em)">
          {matches => (
            <Fragment>
              {matches && (
                <ItemTextWrapper>
                  <ItemTextSmall>Warenkorb</ItemTextSmall>
                  <CartTotal total={total} />
                </ItemTextWrapper>
              )}
            </Fragment>
          )}
        </Media>
      </Toggle>
    </HeaderNavItemWithBorder>
  );
};

const enhancedCustomerNumber = hideIfNoData(props => !props.customer_number);
const CustomerNumber = enhancedCustomerNumber(({ customer_number }) => (
  <ItemTextLarge>{customer_number}</ItemTextLarge>
));

export const HeaderProfileItem = ({ customer_number }) => (
  <HeaderNavItemWithBorder>
    <ProfileIcon width={30} height={30} />
    <ItemTextWrapper>
      <ItemTextSmall>Kundennummer</ItemTextSmall>
      <CustomerNumber customer_number={customer_number} />
    </ItemTextWrapper>
  </HeaderNavItemWithBorder>
);



// WEBPACK FOOTER //
// ../shop_main/components/header/headerItems.js